<template>
  <div class="">

    <div class="flex justify-between flex-wrap lg:flex-no-wrap my-4 py-2 w-full border-b border-slate-200">
      <div class="pb-2">
            <span
              @click.prevent="type = 'stumps'"
              :class="type === 'stumps' ? 'text-blue-700 rounded-lg bg-slate-100' : 'text-slate-500'"
              class="w-full text-center md:w-auto mr-0 md:mr-3 p-3 font-semibold cursor-pointer hover:text-blue-600">
                Stumps to be Removed
              <span :class="type === 'stumps' ? 'bg-blue-200 text-blue-700' : 'bg-slate-100 text-slate-500'"
                    class="hidden px-2 rounded-full font-semibold md:inline-block">{{ stumps.length }}</span>
            </span>
        <span
          @click.prevent="type = 'recent'"
          :class="type === 'recent' ? 'text-blue-700 rounded-lg bg-slate-100' : 'text-slate-500'"
          class="w-full text-center md:w-auto mr-0 md:mr-3 p-3 font-semibold cursor-pointer hover:text-blue-600">
                Recently Removed
              <span :class="type === 'recent' ? 'bg-blue-200 text-blue-700' : 'bg-slate-100 text-slate-500'"
                    class="hidden px-2 rounded-full font-semibold md:inline-block">{{ removedStumps.length }}</span>
            </span>
      </div>
      <div>
        <a v-if="stumps.length > 0" href="/stumps"
           class="text-white rounded-lg bg-blue-600 w-full text-center md:w-auto mr-0 md:mr-3 p-3 font-semibold cursor-pointer hover:text-blue-200">
          Show Map
        </a>
      </div>
    </div>

    <div class="">
    </div>

    <div v-if="type === 'stumps'" class="flex flex-wrap items-center pb-6">
      <div class="w-full lg:w-3/4">
        <p class="my-3 text-xl text-slate-600">
          Stumps to be Removed ({{ stumps.length }})
        </p>
        <p class="my-3 text-md text-slate-500">
          Stump Removals assign to you. Click the Tree ID to view the location on the map.
        </p>
      </div>

      <div class="ftree-table striped hovered main-first-cell w-full overflow-x-auto py-4">
        <div class="thead">
          <div class="tr py-2">
            <div class="td items-center w-1/2 lg:w-1/5">Tree ID</div>
            <div class="td items-center w-1/2 lg:w-1/5">Stump Size</div>
            <div class="td items-center w-1/2 lg:w-2/5">Approx Address</div>
            <div class="td items-center w-1/2 lg:w-1/5">Last Updated</div>
          </div>
        </div>
        <div class="tbody text-left text-slate-700">
          <div
            v-for="(tree, index) in stumps"
            :key="index"
            class="tr border-b border-slate-200"
          >
            <div class="td py-2 w-1/2 lg:w-1/5 items-center">
              <span v-if="tree.stump && tree.stump.priority === 1"
                    class="rounded-full ring-2 w-5 text-center ring-white bg-green-500 text-xs p-1 font-semibold text-white uppercase"
                    title="Low">L</span>
              <span v-if="tree.stump && tree.stump.priority === 2"
                    class="rounded-full ring-2 w-5 text-center ring-white bg-orange-400 text-xs p-1 font-semibold text-white uppercase"
                    title="Medium">M</span>
              <span v-if="tree.stump && tree.stump.priority === 3"
                    class="rounded-full ring-2 w-5 text-center ring-white bg-red-600 text-xs p-1 font-semibold text-white uppercase"
                    title="High">H</span>
              <a :href="'/stumps?treeId='+tree.id" class="py-2 text-slate-600 font-bold mx-2">#{{ tree.id }}</a>
            </div>
            <div class="td py-2 w-1/2 lg:w-1/5 items-center">
              <span v-if="tree.stump_size" class="py-2 mr-2 font-bold">{{ tree.stump_size.name }}</span>
            </div>
            <div class="td py-2 w-1/2 lg:w-2/5 items-center">
              <span v-if="tree.approx_address" class="py-2 mr-2 text-slate-500 text-xs">{{
                  tree.approx_address.length < 40 ? tree.approx_address : tree.approx_address.substring(0, 40) + ".."
                }}</span>
              <span v-else class="py-2 mr-2 text-slate-400 text-xs italic">No close address</span>
            </div>
            <div class="td py-2 w-1/2 lg:w-1/5 items-center text-slate-500">{{ forestreeHelpers.dateTime(tree.updated_at) }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="type === 'recent'" class="flex flex-wrap items-center pb-6">
      <div class="w-full lg:w-3/4">
        <p class="my-3 text-xl text-slate-600">
          Stumps Recently Removed ({{ removedStumps.length }})
        </p>
      </div>

      <div class="ftree-table striped hovered main-first-cell w-full overflow-x-auto py-4">
        <div class="thead">
          <div class="tr py-2">
            <div class="td items-center w-1/2 lg:w-1/5">Tree ID</div>
            <div class="td items-center w-1/2 lg:w-1/5">Stump Size</div>
            <div class="td items-center w-1/2 lg:w-2/5">Approx Address</div>
            <div class="td items-center w-1/2 lg:w-1/5">Removed Date</div>
          </div>
        </div>
        <div class="tbody text-left text-slate-700">
          <div
            v-for="(tree, index) in removedStumps"
            :key="index"
            class="tr border-b border-slate-200"
          >
            <div class="td py-2 w-1/2 lg:w-1/5 items-center">
              <span class="py-2 text-slate-600 font-bold mx-2">#{{ tree.id }}</span>
            </div>
            <div class="td py-2 w-1/2 lg:w-1/5 items-center">
              <span v-if="tree.stump_size" class="py-2 mr-2 font-bold">{{ tree.stump_size.name }}</span>
            </div>
            <div class="td py-2 w-1/2 lg:w-2/5 items-center">
              <span v-if="tree.approx_address" class="py-2 mr-2 text-slate-500 text-xs">{{
                  tree.approx_address.length < 40 ? tree.approx_address : tree.approx_address.substring(0, 40) + ".."
                }}</span>
            </div>
            <div class="td py-2 w-1/2 lg:w-1/5 items-center text-slate-500">{{ forestreeHelpers.dateTime(tree.removed_date) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import moment from "moment";
import {ref} from 'vue'
import forestreeHelpers from "@/helpers/forestreeHelpers";

const props = defineProps(['stumps', 'removedStumps']);

const page = ref(1)
const type = ref('stumps')
const stumpsTotal = ref(null)
const contractors = ref(null)
const contractorId = ref(null)
const tasks = ref(null)
const costCentre = ref(null)
const poNumber = ref(null)
const notes = ref(null)
const today = ref(moment().format("dddd Do MMM YYYY"))
const year = ref(parseInt(moment().format("YYYY")))
const currYear = ref(parseInt(moment().format("YYYY")))
const showModal = ref(false)
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 500px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
